import { call } from '../utils/api';
const USER_STORAGE_KEY = 'user';
const CREDS_STORAGE_KEY = 'creds';
const secret = 'bWFnYXppbmU';
const shiftStart = 4;

const splice = (str, start, newSubStr, delCount = 0) => {
  return (
    str.slice(0, start) + newSubStr + str.slice(start + Math.abs(delCount))
  );
};

const remove = (str, start, end) => {
  return str.slice(0, start) + str.slice(start + end);
};

class UserService {
  constructor() {
    let user = localStorage.getItem(USER_STORAGE_KEY);
    if (user) {
      user = JSON.parse(user);
      this.setToken(user.sessionToken);
      this.setUser(user);
    }
  }

  setUser(user) {
    this.user = user;
  }

  getUser() {
    return this.user;
  }

  setUserCreds(data) {
    // add expired params 2 weeks
    data.expired = Date.now() + 60 * 60 * 24 * 14 * 1000;
    const hash = window.btoa(JSON.stringify(data));
    localStorage.setItem(CREDS_STORAGE_KEY, splice(hash, shiftStart, secret));
  }

  getUserCreds() {
    let data = localStorage.getItem(CREDS_STORAGE_KEY);
    let creds = false;
    if (data) {
      try {
        data = JSON.parse(window.atob(remove(data, shiftStart, secret.length)));
        if (data.expired >= Date.now()) {
          delete data.expired;
          creds = data;
        }
      } catch (e) {
        //ignore
      }
    }
    return creds;
  }

  unsetUser() {
    this.setUser(null);
    localStorage.removeItem(USER_STORAGE_KEY);
    localStorage.removeItem(CREDS_STORAGE_KEY);
  }

  setToken(token) {
    this.token = token;
  }

  getToken() {
    return this.token;
  }

  login({ email, password, remember_me = false }) {
    const self = this;
    return call(
      'authentication/login',
      'POST',
      { name: email, password },
      false
    )
      .then(user => {
        // login successful if there's a jwt token in the response
        if (user.sessionToken) {
          self.setToken(user.sessionToken);
          self.setUser(user);
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem(USER_STORAGE_KEY, JSON.stringify(user));
          if (remember_me) {
            self.setUserCreds({ email, password });
          }
          localStorage.removeItem('confirmEmail');
        }

        return user;
      })
      .catch(e => {
        self.unsetUser();
        return Promise.reject(e);
      });
  }

  logout() {
    // remove user from local storage to log user out
    this.setToken(null);
    this.unsetUser();
  }

  resetPassword(email, source_url) {
    return call(
      'authentication/reset/password',
      'POST',
      { email, source_url },
      false
    );
  }

  updatePassword(token, password) {
    return call(
      'authentication/update/password',
      'POST',
      { token, password },
      false
    );
  }

  resendActivation(email, sourceUrl) {
    return call(
      'authentication/user/activation/mail',
      'POST',
      { email, sourceUrl },
      false
    );
  }

  /**
   *
   * @param user {
   * 	"password": "string",
   *  "name": "string",
   *  "familyName": "string",
   *  "company": "company",
   *  "email": "string",
   *  "source_url": "string"
   * }
   */
  register(user) {
    return call('authentication/register', 'POST', user, false).then(user => {
      localStorage.setItem('confirmEmail', user.email);
    });
  }
}

export const userService = new UserService();



// WEBPACK FOOTER //
// ./src/services/userService.js